import { z } from 'zod';

export const quickDeployAcceptedZod = z.object({
  operationId: z.string().uuid(),
  currentStep: z.literal('accepted'),
});

const quickDeployFields = {
  operationId: z.string().uuid(),
  currentStep: z.enum([
    'accepted',
    'prepare-deploy',
    'creating-draft',
    'updating-draft',
    'deploying',
    'completed',
    'failed',
  ]),
  message: z.string(),
  resultingVersion: z.string().nullish(),
  error: z.string().nullish(),
};

export const quickDeployUpdateZod = z.object({
  ...quickDeployFields,
  timestamp: z.string().datetime(),
});

export const quickDeployStateZod = z
  .object({
    ...quickDeployFields,
    updatedAt: z.string().datetime(),
  })
  .transform(({ updatedAt, ...progress }) => ({
    ...progress,
    timestamp: updatedAt,
  }));

export type QuickDeployProgress = z.infer<typeof quickDeployUpdateZod>;
